import { createContext } from 'react';

import { ITimeUnit } from '~/helpers/types';
import { type IStorageLocation } from '~/lib/storage';

export type IPersistentFormContextValue = {
  cacheNamespace: string;
  cacheLocation: IStorageLocation;
  timeout?: number;
};

export const persistentFormInitialContextValue: IPersistentFormContextValue = {
  cacheNamespace: 'form',
  cacheLocation: 'local',
  timeout: 30 * ITimeUnit.MINUTE,
};

export const PersistentFormContext = createContext<IPersistentFormContextValue>(
  persistentFormInitialContextValue,
);
